<template>
  <v-container fluid class="pa-0 bg-primary-gradient">
    <v-toolbar :class="{ 'mb-4': !(noPadding || subtitle) }" flat dense extended color="transparent" dark :title="currentRoute.text">
      <router-link :to="{ name: 'home'}">
        <v-icon size="20px" class="mr-2" title="Home">home</v-icon>
      </router-link>
      <v-icon small>chevron_right</v-icon>
      <v-breadcrumbs class="white-breadcrumbs drop-shadow font-weight-light" dark :items="breadcrumbs" divider=">">
        <template v-slot:divider>
          <v-icon>chevron_right</v-icon>
        </template>
        <template v-slot:item="props">
          <v-breadcrumbs-item v-if="props.item !== currentRoute" exact :to="props.item.to">
            {{ props.item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <v-toolbar-title slot="extension" :class="{ 'loading-dots': loading }" class="display-2 pb-2 drop-shadow" style="margin-left: 0px; padding-bottom: 15px">
        <slot v-if="this.$slots.title" name="title" />
        <template v-else>
          <v-icon large style="padding-bottom: 10px">{{ currentRoute.icon }}</v-icon>
          {{ currentRoute.text }}
          <template v-if="loading">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </template>
        </template>
      </v-toolbar-title>
    </v-toolbar>
    <slot v-if="this.$slots.subtitle" name="subtitle" />
    <v-toolbar v-else-if="subtitle" :class="{ 'mb-4': !noPadding }" flat dense color="transparent" dark>
      <span class="subheading drop shadow font-weight-regular body-2" v-html="subtitle" />
    </v-toolbar>
  </v-container>
</template>

<script>
  export default {
    props: {
      icon: String,
      title: String,
      subtitle: String,
      noPadding: Boolean,
      loading: Boolean,
    },
    computed: {
      currentRoute() {
        return {
          text: this.currentRouteText,
          icon: this.icon || this.$route.meta.icon,
          to: {
            name: this.$route.name,
            path: this.$route.path,
          },
          disabled: true,
        }
      },
      currentRouteText() {
        const title = this.title || this.$route.meta.title
        const nameOrPath = this.$route.name || this.$route.path
        const langName = this.$t(`App.${nameOrPath}`)
        return title || langName || nameOrPath
      },
      breadcrumbs() {
        if (!this.$route.meta.breadcrumbs) {
          return [this.currentRoute]
        }

        let leadingRoutes = this.$route.meta.breadcrumbs.map(breadcrumb => {
          return {
            text: breadcrumb.title,
            // to: breadcrumb.link,
            to: breadcrumb.link || null,
            disabled: false,
          }
        })
        return [...leadingRoutes, this.currentRoute]
      },
    },
  }
</script>

<style>
  .white-breadcrumbs>li>a {
    color: white;
  }

  .disabled-breadcrumb {
    background: transparent !important;
    color: transparent !important;
    cursor: default !important;
  }

  .disabled-breadcrumb>.v-btn__content {
    color: hsla(0, 0%, 100%, 0.5);
  }

  .drop-shadow {
    filter: drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.3));
  }
</style>